import slideStyle from "./InfoPage.module.scss";
import Badge from "../components/Badge/Badge";
import ContactAppendix from "./ContactAppendix";
import Heading from "./Heading";
import { getMessage, Message, MessageContext } from "@messageformat/react";
import { useContext } from "react";

const KioskAI = () => {
  const messageContext = useContext(MessageContext);

  return (
    <>
      <Heading
        subtitle={<Message id="infoPages.discountSystem.subtitle" />}
        title={<Message id="infoPages.discountSystem.title" />}
        hints={[
          <Message id="infoPages.discountSystem.hints.hint1" />,
          <Message id="infoPages.discountSystem.hints.hint2" />,
          <Message id="infoPages.discountSystem.hints.hint3" />,
        ]}
      />
      <div className={slideStyle.section}>
        <div>
          <h2
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.discountSystem.sectionTitle"
              )(),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.discountSystem.description"
              )(),
            }}
          />
          <p
            style={{ fontWeight: "bold" }}
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.discountSystem.comingSoon"
              )(),
            }}
          />
        </div>

        <div
          className={slideStyle.heading}
          style={{ marginTop: "20px", marginBottom: "20px" }}
        >
          <h1
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.discountSystem.summary"
              )(),
            }}
          />
        </div>

        <ContactAppendix />
      </div>
    </>
  );
};

export default KioskAI;
